export default "__VITE_ASSET__gcYH4jrI__"